/* global google */
/* global ParamsData */
import Swiper from 'swiper';

export default blockPlacesMap => {

    const ww = window.innerWidth;
    const main = document.querySelector('main');
    const destination = main.getAttribute('data-destination');
    const category = main.getAttribute('data-cat');
    const latitude = main.getAttribute('data-lat');
    const longitude = main.getAttribute('data-lng');
    const north = main.getAttribute('data-north');
    const east = main.getAttribute('data-east');
    const south = main.getAttribute('data-south');
    const west = main.getAttribute('data-west');
    const pageId = blockPlacesMap.getAttribute('data-page-id');
    const destinationId = blockPlacesMap.getAttribute('data-destination-id');
    const posttype = blockPlacesMap.getAttribute('data-post-type');
    const placesList = blockPlacesMap.querySelector('.places-list');
    const mapContainer = blockPlacesMap.querySelector('.map-container');
    let markers = [];
    let placesMap = '';


    function makeCard() {

        const placeCards = blockPlacesMap.querySelectorAll('.card-place');

        for (const placeCard of placeCards) {
            placeCard.addEventListener('mouseenter', () => {
                const index = Array.prototype.slice.call(placeCards).indexOf(placeCard);
                const lat = markers[index].position.lat();
                const lng = markers[index].position.lng();
                const center = new google.maps.LatLng({ lat, lng });

                if (ww >= 768) {
                    google.maps.event.trigger(markers[index], 'click');
                }
                //placesMap.setCenter(center);
                //placesMap.setZoom(10);
            });
        }
    }

    function getMarkerId(marker) {
        for (let i = 0; i < markers.length; i++) {
            if (markers[i] === marker) {
                return i;
            }
        }
        return null;
    }

    function resetPlaceCards() {
        const placeCards = blockPlacesMap.querySelectorAll('.card-place');

        for (const placeCard of placeCards) {
            placeCard.classList.remove('active');
        }
    }

    function resetIcons() {
        const markerIcon = {
            url: `${ParamsData.wp_theme_url}assets/img/pin-yellow.png`,
            size: new google.maps.Size(30, 50),
            scaledSize: new google.maps.Size(30, 50),
        };

        for (const marker of markers) {
            marker.setIcon(markerIcon);
            marker.setZIndex(1);
        }
    }

    function setCurrentIcon(marker) {
        const markerIcon = {
            url: `${ParamsData.wp_theme_url}assets/img/pin-green.png`,
            size: new google.maps.Size(30, 50),
            scaledSize: new google.maps.Size(30, 50),
        };

        marker.setIcon(markerIcon);
        marker.setZIndex(2);
    }

    function displayMobileCard(placeCard) {

        const bloc = placeCard.parentNode.querySelector('.mobile-content');
        const id = placeCard.getAttribute('data-id');

        const mobileCardContainer = blockPlacesMap.querySelector('.mobile-card-container');

        let card = '';
        card += '<div class="card-place list" data-id="' + id + '">' + bloc.innerHTML + '</div>';

        mobileCardContainer.innerHTML = card;
    }

    function setMarkers(map) {

        for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
        markers = [];

        const placeCards = blockPlacesMap.querySelectorAll('.card-place');
        const bounds = new google.maps.LatLngBounds();
        const icon = {
            url: `${ParamsData.wp_theme_url}assets/img/pin-yellow.png`,
            size: new google.maps.Size(30, 50),
            scaledSize: new google.maps.Size(30, 50),
        };

        for (const placeCard of placeCards) {

            const type = placeCard.parentNode.getAttribute('data-type');
            const dataLat = placeCard.parentNode.getAttribute('data-latitude');
            const dataLng = placeCard.parentNode.getAttribute('data-longitude');

            const position = new google.maps.LatLng(dataLat, dataLng);

            if (type === 'golf') {
                icon.type = 'golf';
            } else if (type === 'hotel') {
                icon.type = 'hotel';
            } else {
                icon.type = 'pin';
            }

            const marker = new google.maps.Marker({ position, map, icon });

            bounds.extend(marker.position);

            marker.addListener('click', event => {
                resetPlaceCards();

                placeCards[getMarkerId(marker)].classList.add('active');

                if (event !== undefined) {
                    placeCards[getMarkerId(marker)].scrollIntoView({
                        block: 'center',
                    });
                }

                ww < 768 && displayMobileCard(placeCard);

                resetIcons();
                setCurrentIcon(marker);
            });

            markers.push(marker);
        }

        /*if(north !== null && north != ""){
          var specialBounds = new google.maps.LatLngBounds();
          specialBounds.extend(new google.maps.LatLng(north, east));
          specialBounds.extend(new google.maps.LatLng(south, west));
          map.fitBounds(specialBounds);
          setTimeout(function(){
            if(map.getZoom() > 10){
              map.setZoom(10);
            }
          }, 200);
        }else */if (placeCards.length >= 1) {
            map.fitBounds(bounds);
            setTimeout(function () {
                if (map.getZoom() > 8) {
                    map.setZoom(8);
                }
            }, 200);
        } else {
            map.setCenter(new google.maps.LatLng(placeCards[0].getAttribute('data-latitude'), placeCards[0].getAttribute('data-longitude')));
            map.setZoom(10);
        }

        mapContainer.addEventListener('mapreload', function (e) {
            map.fitBounds(bounds);

        });


        // google.maps.event.trigger(markers[0], 'click');
    }

    function initPlacesMap() {

        placesMap = new google.maps.Map(mapContainer, {
            zoom: 10,
            fullscreenControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            styles: [
                {
                    featureType: 'administrative',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#444444',
                        },
                    ],
                },
                {
                    featureType: 'landscape',
                    elementType: 'all',
                    stylers: [
                        {
                            color: '#F2F2F2',
                        },
                    ],
                },
                {
                    featureType: 'poi',
                    elementType: 'all',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'road',
                    elementType: 'all',
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            lightness: 45,
                        },
                    ],
                },
                {
                    featureType: 'road.highway',
                    elementType: 'all',
                    stylers: [
                        {
                            visibility: 'simplified',
                        },
                    ],
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'transit',
                    elementType: 'all',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'water',
                    elementType: 'all',
                    stylers: [
                        {
                            color: '#A3C9D8',
                        },
                        {
                            visibility: 'on',
                        },
                    ],
                },
                {
                    featureType: 'water',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#B9D5EC',
                        },
                    ],
                },
            ],
        });

        setMarkers(placesMap);
    }

    function getDatas(lat, lng) {

        orderPlacesBlocs();

        return;
        /*
                // console.log('lat', lat);
                // console.log('lng', lng);
                const request = new XMLHttpRequest();
                const url = ParamsData.wp_ajax_url;
                const ajaxData = new FormData();
        
                ajaxData.append('action', blockPlacesMap.getAttribute('data-action'));
                ajaxData.append('nonce', blockPlacesMap.getAttribute('data-nonce'));
                ajaxData.append('page_id', pageId);
                ajaxData.append('destination_id', destination);
                ajaxData.append('post_type', posttype);
        
                if (destinationId !== null) {
                    ajaxData.append('destinationId', destinationId);
                }
        
                if (category !== null) {
                    ajaxData.append('category', category);
                }
        
                if (lng !== undefined) {
                    ajaxData.append('longitude', lng);
                }
        
                if (lat !== undefined) {
                    ajaxData.append('latitude', lat);
                }
        
                request.open('POST', url, true);
        
                request.send(ajaxData);
        
                request.onprogress = () => {
                    // console.log('onprogress...');
                };
        
                request.onload = () => {
                    let response = request.response;
        
                    if (typeof response === 'string') {
                        response = JSON.parse(response);
                    }
        
                    // console.log(response);
        
                    blockPlacesMap.classList.remove('loading');
        
                    makeCard(response.json_places);
                    initPlacesMap(response.json_places);
                };
        
                request.onerror = () => {
                    // console.log('onerror...');
                };*/
    }

    function geoSuccess(position) {
        // console.log('géolocalisation accordée');
        getDatas(position.coords.latitude, position.coords.longitude);
    }

    function geoError() {
        // console.log('géolocalisation refusée');
        getDatas();
    }

    function getGeolocation() {
        if (latitude !== null && longitude !== null) {
            getDatas(latitude, longitude);
        } else if ('geolocation' in navigator) {
            // console.log('géolocalisation possible');
            // console.log('géolocalisation demandée');
            navigator.geolocation.getCurrentPosition(geoSuccess, geoError);
        } else {
            // console.log('géolocalisation impossible');
            getDatas();
        }
    }


    function reorderPlacesByLocation(latPos, lngPos) {

        const orderPlaces = blockPlacesMap.querySelectorAll('.place-item');

        var arrayPlaces = [];
        for (const placeCard of orderPlaces) {
            var latitudePlace = placeCard.getAttribute('data-latitude');
            var longitudePlace = placeCard.getAttribute('data-longitude');
            arrayPlaces.push({
                'distance': getDistanceFromLatLonInKm(latPos, lngPos, latitudePlace, longitudePlace),
                'html': placeCard.cloneNode(true)
            });
        }

        arrayPlaces.sort(function (a, b) {
            return a.distance - b.distance;
        });

        var fakeElement = document.createElement('div');
        for (const arrayPlace of arrayPlaces) {
            fakeElement.appendChild(arrayPlace.html);
        }
        placesList.innerHTML = fakeElement.innerHTML;

        makeCard();
        initPlacesMap();

    }

    function geoSuccessPlaces(position) {
        var latPos = position.coords.latitude;
        var lngPos = position.coords.longitude;
        reorderPlacesByLocation(latPos, lngPos);
    }

    function geoErrorPlaces() {
        makeCard();
        initPlacesMap();
    }

    function orderPlacesBlocs() {
        makeCard();
        initPlacesMap();
        if (latitude == null && longitude == null && 'geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(geoSuccessPlaces, geoErrorPlaces);
        }
    }


    function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
        var R = 6371; // Radius of the earth in km
        var dLat = deg2rad(lat2 - lat1);  // deg2rad below
        var dLon = deg2rad(lon2 - lon1);
        var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2)
            ;
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in km
        return d;
    }

    function deg2rad(deg) {
        return deg * (Math.PI / 180)
    }

    getDatas();
    //getGeolocation();
};
